import React from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";

const Popup = ( props ) => {

  const { t } = useTranslation();

  const confirm = () => {
    props.onConfirm();
    if (props.onClose) props.onClose();
    else props.onHide();
    
  };

  const buttonLabel = props.buttonLabel.length ? props.buttonLabel : [ t( 'LC_05_20.msg022' ), t( 'LC_05_20.msg023' ) ];

  const BUTTONS = buttonLabel.map( ( value, index ) => {
    if ( index ) {
      return (
        <Button 
          key={index} 
          className="btn btn-gray" 
          onClick={props.onClose ? props.onClose : props.onHide }
        >
          { value }
        </Button>
      );
    } else {
      return <Button key={ index } className="btn btn-blue" onClick={ confirm }>{ value }</Button>;
    }
  } );

  return (
    <div className="lp-container lc-alert lc-def" >
      { props.children }
      <div className="lp-btnBox">
        { [ ...BUTTONS ].reverse() }
      </div>
    </div>
  );

};

Popup.defaultProps = {
  buttonLabel : [],
  onConfirm : () => {},
  onHide : () => {}
};

export default Popup;
